<bd-interactive-applied-filters
  [filters]="appliedFilters()"
  [attributeCategoryDefinitions]="attributeCategoryDefinitions()"
  [editContext]="editContext()"
  (updateFilter)="onUpdateFilter($event)"
  (removeFilter)="onRemoveFilter($event)"
  (clearAllFilters)="onClearAllFilters()"
  (searchObjects)="onSearchObjects($event)"
  (searchUsers)="searchUsers.emit($event)"
/>
